import Vue from 'vue'
import Vuex from 'vuex'
import { login as loginApi, logout as logoutApi, getCurrentUser } from '../api/auth'
import { getToken, setToken, setRefreshToken, clearAuth, getStoredUser, setStoredUser } from '../utils/auth'

Vue.use(Vuex)

const initialUser = getStoredUser() || { name: '管理员', role: 'campus_admin' }

export default new Vuex.Store({
  state: {
    sidebarOpened: true,
    token: getToken(),
    user: initialUser,
    permissions: initialUser.permissions || []
  },
  mutations: {
    toggleSidebar(state) { state.sidebarOpened = !state.sidebarOpened },
    SET_AUTH(state, { token, user }) { state.token = token; state.user = user; state.permissions = user.permissions || [] },
    CLEAR_AUTH(state) { state.token = ''; state.user = {}; state.permissions = [] }
  },
  actions: {
    async login({ commit }, { username, password, remember }) {
      const data = await loginApi({ username, password })
      setToken(data.accessToken, remember)
      setRefreshToken(data.refreshToken, remember)
      const user = await getCurrentUser()
      setStoredUser(user, remember)
      commit('SET_AUTH', { token: data.accessToken, user })
      return user
    },
    async fetchCurrentUser({ commit, state }) {
      if (!state.token) return null
      const user = await getCurrentUser()
      setStoredUser(user, Boolean(localStorage.getItem('xxst_admin_access_token')))
      commit('SET_AUTH', { token: state.token, user })
      return user
    },
    async logout({ commit }) {
      try { if (getToken()) await logoutApi() } finally { clearAuth(); commit('CLEAR_AUTH') }
    }
  }
})
